'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createVisitorThreadFailure = exports.createVisitorThreadSuccess = exports.getVisitorThreadHistory = exports.getVisitorThreadsFailure = exports.getVisitorThreadsSuccess = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.fetchVisitorThreads = fetchVisitorThreads;
exports.navigateToMostRecentThread = navigateToMostRecentThread;

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _reduxActions = require('redux-actions');

var _ThreadSources = require('conversations-schema/constants/ThreadSources');

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _Responder = require('conversations-schema/responders/records/Responder');

var _Responder2 = _interopRequireDefault(_Responder);

var _buildPublishedMessage = require('conversations-schema/factories/PubNubMessageFactory/buildPublishedMessage');

var _loadExistingThread = require('../../navigation/actions/loadExistingThread');

var _loadStagedThread = require('../../navigation/actions/loadStagedThread');

var _buildConversation = require('conversations-schema/factories/ConversationFactory/buildConversation');

var _getMostRecentOpenThread = require('../../threads/selectors/getMostRecentOpenThread');

var _fetchVisitorThreads = require('../../threads/clients/fetchVisitorThreads');

var _getSessionId = require('../../selectors/widgetDataSelectors/getSessionId');

var _getShowPreviousConversations = require('../../widget-data/selectors/getShowPreviousConversations');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getVisitorThreadsStarted = (0, _reduxActions.createAction)(ActionTypes.GET_VISITOR_THREADS_STARTED);

var getVisitorThreadsSuccess = exports.getVisitorThreadsSuccess = (0, _reduxActions.createAction)(ActionTypes.GET_VISITOR_THREADS_SUCCESS, function (_ref) {
  var threads = _ref.threads;

  var threadMap = threads.map(function (thread) {
    var latestMessageRaw = thread.latestMessage,
        responderRaw = thread.responder,
        threadId = thread.threadId,
        others = _objectWithoutProperties(thread, ['latestMessage', 'responder', 'threadId']);

    var latestMessage = latestMessageRaw ? (0, _buildPublishedMessage.buildPublishedMessage)(_extends({}, latestMessageRaw, { threadId: threadId })) : null;

    var responder = responderRaw ? (0, _Responder2.default)(responderRaw) : null;

    return (0, _buildConversation.buildConversation)(_extends({
      latestMessage: latestMessage,
      responder: responder,
      threadId: threadId
    }, others));
  });

  return { threads: threadMap };
});

var getVisitorThreadsFailure = exports.getVisitorThreadsFailure = (0, _reduxActions.createAction)(ActionTypes.GET_VISITOR_THREADS_FAILURE);

function fetchVisitorThreads() {
  return function (dispatch, getState) {
    dispatch(getVisitorThreadsStarted());

    var sessionId = (0, _getSessionId.getSessionId)(getState());
    var portalId = _hubspot2.default.get();
    var showPreviousConversations = (0, _getShowPreviousConversations.getShowPreviousConversations)(getState());

    var promise = (0, _fetchVisitorThreads.fetchVisitorThreads)({
      limit: !showPreviousConversations ? 1 : 100,
      sessionId: sessionId,
      portalId: portalId
    }).then(function (threads) {
      dispatch(getVisitorThreadsSuccess({ threads: threads }));
    }).catch(function (err) {
      dispatch(getVisitorThreadsFailure(err));
    });
    promise.done();
    return promise;
  };
}

var getVisitorThreadHistory = exports.getVisitorThreadHistory = (0, _reduxActions.createAction)(ActionTypes.GET_VISITOR_THREAD_HISTORY);

var createVisitorThreadSuccess = exports.createVisitorThreadSuccess = (0, _reduxActions.createAction)(ActionTypes.CREATE_VISITOR_THREAD_SUCCESS, function (_ref2) {
  var channel = _ref2.channel,
      threadId = _ref2.threadId;

  var thread = (0, _buildConversation.buildConversation)({
    source: _ThreadSources.LIVE_CHAT,
    threadId: threadId,
    channel: channel
  });

  return {
    threadId: threadId,
    thread: thread,
    channel: channel
  };
});

var createVisitorThreadFailure = exports.createVisitorThreadFailure = (0, _reduxActions.createAction)(ActionTypes.CREATE_VISITOR_THREAD_FAILURE);

function navigateToMostRecentThread() {
  return function (dispatch, getState) {
    var recentThread = (0, _getMostRecentOpenThread.getMostRecentOpenThread)(getState());
    if (recentThread) {
      var threadId = recentThread.threadId,
          channel = recentThread.channel;

      dispatch((0, _loadExistingThread.loadExistingThread)({ threadId: threadId, channel: channel }));
    } else {
      dispatch((0, _loadStagedThread.loadStagedThread)());
    }
  };
}